<template>
  <el-container v-title data-title="食堂货品" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>食堂货品</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <!-- <el-option label="全部" value=""></el-option> -->
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="searchForm.type" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="菜品" value="1"></el-option>
                    <el-option label="商品" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="名称">
                  <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getCanteenGoodsList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="100"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="100"></el-table-column>
          <el-table-column prop="name" label="名称" width="100"></el-table-column>
          <el-table-column prop="price" :formatter="yuanOfPriceFormatter" label="默认价格" width="100"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="100"></el-table-column>
          <el-table-column prop="insertTime" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="creatorRealName" label="创建人" width="170"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="170"></el-table-column>
          <el-table-column prop="updaterRealName" label="修改人" width="170"></el-table-column>
          <el-table-column label="操作" width="141">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
              <el-button type="text" @click="changeStatus(scope.row)">{{ scope.row.status == '1' ? '停用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getCanteenGoodsList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="360px"
        :before-close="handleClose"
        append-to-body>
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="90px">
          <el-form-item label="学校" :required="true" prop="schoolId">
            <el-select v-model="addData.schoolId" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" :required="true" prop="type">
            <el-select v-model="addData.type" placeholder="请选择类型">
              <el-option label="菜品" value="1"></el-option>
              <el-option label="商品" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="addData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="默认价格" :required="true" prop="yuanOfPrice">
            <el-input-number :min="0" :max="10000" :precision="2" v-model="addData.yuanOfPrice" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addCanteenGoods">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="90px">
          <el-form-item label="学校" :required="true" prop="schoolId">
            <el-select v-model="modifyData.schoolId" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" :required="true" prop="type">
            <el-select v-model="modifyData.type" placeholder="请选择类型">
              <el-option label="菜品" value="1"></el-option>
              <el-option label="商品" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="modifyData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="默认价格" :required="true" prop="yuanOfPrice">
            <el-input-number :min="0" :max="10000" :precision="2" v-model="modifyData.yuanOfPrice" style="width: 160px"></el-input-number> 元
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyCanteenGoods">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        type: ''
      },
      addData: {
        yuanOfPrice: 0
      },
      addDialogVisible: false,
      modifyData: {},
      modifyDialogVisible: false,
      rules: {
        schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        yuanOfPrice: [{ required: true, message: '请输入默认价格', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getCanteenGoodsList()
    },
    getCanteenGoodsList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/canteenGoods/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.searchForm.schoolId,
          type: _this.searchForm.type,
          name: _this.searchForm.name,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterCanteen: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getCanteenGoodsList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    openAddDialog () {
      this.addData.price = '0'
      this.addDialogVisible = true
    },
    addCanteenGoods () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          _this.addData.price = (_this.addData.yuanOfPrice * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/canteenGoods/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getCanteenGoodsList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openModifyDialog (canteenGoodsData) {
      console.log(canteenGoodsData)
      this.modifyData = JSON.parse(JSON.stringify(canteenGoodsData))
      this.modifyDialogVisible = true
    },
    modifyCanteenGoods () {
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          _this.modifyData.price = (_this.modifyData.yuanOfPrice * 100).toFixed(0)
          this.$axios.post(this.GLOBAL.host + '/canteenGoods/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getCanteenGoodsList()
                _this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    yuanOfPriceFormatter (row) {
      return this.fenToyuanFormat(row.price)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    },
    changeStatus (canteenGoods) {
      if (canteenGoods === null) return
      let _this = this
      this.$confirm('确认要' + (canteenGoods.status === '1' ? '停用' : '启用') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/canteenGoods/changeStatus',
          this.$qs.stringify({ id: canteenGoods.id, status: canteenGoods.status === '1' ? '0' : '1' })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
            _this.getCanteenGoodsList()
          }
        })
      })
    }
  },
  watch: {
    tableData () {
      this.tableData.forEach(element => {
        if (element.price != null && element.price > 0) {
          element.yuanOfPrice = element.price / 100
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CanteenGoods.vue